import React from 'react';

import { Rod } from './styles';

export default function Rodape() {
  return (
    <Rod>
      <h3>Curso e Mentorias em Aprendizagem, Oratória e Produtividade</h3>
      <span>
        Rua Sousa Ramos, 88 – Metrô Santa Cruz - WhatsApp: 11 3288-2777
      </span>
      <span>&copy; Copyright Methodus - Todos os direitos reservados.</span>
    </Rod>
  );
}
